import React, { useState } from "react";
import { supabase } from "../supabase";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/register.css";
import { friendlyAuthError } from "../lib/friendlyErrors";

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("info");

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setMessage("");

    const form = event.target;
    const email = form.email.value.trim();
    const password = form.password.value;

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      console.error("Login failed:", error);
      setMessageType("error");
      setMessage(friendlyAuthError(error, "Incorrect email or password."));
      setLoading(false);
      return;
    }

    if (!data.user) {
      setMessageType("error");
      setMessage("We could not sign you in right now.");
      setLoading(false);
      return;
    }

    setMessageType("success");
    setMessage("Signed in successfully.");

    const redirectTo = location.state?.from || "/";
    navigate(redirectTo, { replace: true });
    setLoading(false);
  };

  return (
    <section className="auth-section">
      <div className="auth-box">
        <div className="welcome-message">
          <h2>Welcome back</h2>
          <p>Sign in to continue to your account and manage your requests.</p>
        </div>

        {message ? <div className={`login-message ${messageType}`}>{message}</div> : null}

        <form onSubmit={handleLogin}>
          <input name="email" type="email" placeholder="Email address" required />
          <input name="password" type="password" placeholder="Password" required />

          <div className="auth-footer">
            <a href="/reset-password">Forgot your password?</a>
            <br />
            <br />
          </div>

          <button className="auth-btn" disabled={loading}>
            {loading ? "Signing in..." : "Sign in"}
          </button>

          <div className="auth-footer">
            Don&apos;t have an account? <a href="/register">Create one here</a>
          </div>
        </form>
      </div>
    </section>
  );
}

export default Login;
